import { createSelector } from '@ngrx/store';

import { AppState } from '../app.reducer';
import { AppStateWithChat, chatInitialState } from '../modules/chat/store/chat.reducer';
import { uiInitialState } from '../modules/shared/store/ui.reducer';
import { userInitialState } from '../modules/user/store/user.reducer';

export const selectUiState = createSelector(
  (state: AppState) => state.ui,
  (ui) => ui ?? uiInitialState
);

export const selectUserState = createSelector(
  (state: AppState) => state.user,
  (user) => user ?? userInitialState
);

export const selectUser = createSelector(selectUserState, (user) => user.user);

export const selectChatState = createSelector(
  (state: AppStateWithChat) => state.chat,
  (chat) => chat ?? chatInitialState
);

export const selectSelectedChannel = createSelector(selectChatState, (chat) => chat.selectedChannel);

export const selectSelectedWorkSpace = createSelector(selectChatState, (chat) => chat.selectedWorkSpace);

export const selectChannels = createSelector(selectChatState, (chat) => chat.channels);

export const selectTags = createSelector(selectChatState, (chat) => chat.tags);

export const selectChannelsFilter = createSelector(selectChatState, (chat) => chat.channelsFilter);

export const selectVideoCall = createSelector(selectChatState, (chat) => chat.videoCall);

export const selectUnreadMessages = createSelector(selectChatState, (chat) => chat.unreadMessages);

export const selectChatUsers = createSelector(selectChatState, (chat) => chat.users);

export const selectMessagesFilter = createSelector(selectChatState, (chat) => chat.messagesFilter);

export const selectTokenAuthentication = createSelector(selectChatState, (chat) => chat.tokenAuthentication);

export const selectStandardResponses = createSelector(selectChatState, (chat) => chat.standardResponses);

export const selectShowChannelsFilters = createSelector(selectUiState, (ui) => ui.showChannelsFilters);

export const selectShowScrollButton = createSelector(selectUiState, (ui) => ui.showScrollButton);

export const selectScrollPosition = createSelector(selectUiState, (ui) => ui.scrollPosition);

export const selectShowChannels = createSelector(selectUiState, (ui) => ui.showChannels);

export const selectShowBackArrow = createSelector(selectUiState, (ui) => ui.showBackArrow);

export const selectIsLoadingUsers = createSelector(selectUiState, (ui) => ui.isLoadingUsers);

export const selectIsFullScreenVideoCall = createSelector(selectUiState, (ui) => ui.isFullScreenVideoCall);

export const selectIsLoadingResolve = createSelector(selectUiState, (ui) => ui.isLoadingResolve);

export const selectIsLoadingTags = createSelector(selectUiState, (ui) => ui.isLoadingTags);

export const selectIsLoadingAway = createSelector(selectUiState, (ui) => ui.isLoadingAway);
